import { Dialog, DialogTitle, DialogContent, TextField, DialogActions } from "@mui/material"
import { Box, Grid } from "@mui/system"
import ButtonGradient from "../Filter/Components/ButtonGradient"
import ButtonLightGray from "../Filter/Components/ButtonLightGray"
import GridContainer from "../Filter/Components/grid/GridContainer"
import DialogTitleClose from "../Misc/Dialog/Components/DialogTitleClose"
import { useContext, useState } from "react"
import DialogGridIcon from "../Misc/Dialog/Components/DialogGridIcon"
import DialogGridText from "../Misc/Dialog/Components/DialogGridText"
import DialogTypographyText from "../Misc/Dialog/Components/DialogTypographyText"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { handleStringLengthHelper } from "../../helpers/displayStringHelpers"
import StyledTooltip from "../Misc/StyledTooltip"
import { useSnackbar } from "notistack"
import { APIsContext } from "../../Store/APIs/context"

interface IDeleteAccountDialogProps {
    username: string
    askForPassword?: boolean,
    open: boolean,
    setOpen: (open: boolean) => void
    rerender: () => {}
}

const DeleteAccountDialog: React.FC<IDeleteAccountDialogProps> = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const apisState = useContext(APIsContext).state
    const [passwordError, setPasswordError] = useState(false)

    const handleOnClose = () => {
        props.setOpen(false)
    }

    const handleExit = () => {
        setPasswordError(false)
    }

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const password = new FormData(event.currentTarget).get("account-password") as string;
        if (props.askForPassword) {
            if ((password === null || password === "")) {
                enqueueSnackbar("Password must not be blank", {variant: "warning"})
                setPasswordError(true)
                return
            } else {
                setPasswordError(false)
            }
        }

        apisState.AccountsApi.deleteAccounts({
            deleteAccountsRequest: {
                accounts: [{
                    username: props.username,
                    password: password
                }]
            }
        }).then(res => {
            if (res.status === 200) {
                if (res.data === 1) {
                    enqueueSnackbar("Successfully deleted account", {variant: "info"})
                    props.rerender()
                } else {
                    enqueueSnackbar("Invalid password", {variant: "warning"})
                    setPasswordError(true)
                    return
                }
            } else {
                enqueueSnackbar("Failed to delete account", {variant: "error"})
            }
            props.setOpen(false)
        }).catch(err => {
            enqueueSnackbar(err.message, {variant: "error"})
        })
    }

    return (
        <Dialog
            maxWidth="xs"
            scroll="body"
            fullWidth
            open={props.open}
            onClose={handleOnClose}
            onTransitionExited={handleExit}
        >
            <Box component="form" onSubmit={handleSubmit} noValidate >
                <DialogTitle>
                    <DialogTitleClose title={"Delete account"} onClose={handleOnClose}/>
                </DialogTitle>
                <DialogContent style={{paddingBottom: props.askForPassword? "0px" : "1rem", paddingLeft: "0px", paddingRight: "0px"}}>
                    <Grid container>
                        <DialogGridIcon item xs={2}>
                            <InfoOutlinedIcon style={{fontSize: 40}} />
                        </DialogGridIcon>
                        <DialogGridText item xs={10}>
                            <DialogTypographyText>
                                Are you sure you want to delete <StyledTooltip title={props.username}><b>{handleStringLengthHelper(props.username)}</b></StyledTooltip>?
                            </DialogTypographyText>
                        </DialogGridText>
                    </Grid>
                    {props.askForPassword? 
                        <GridContainer container style={{paddingTop: "0.5rem", paddingRight: "2rem", paddingLeft: "2rem"}}>
                            <TextField
                                sx={{margin: "none"}}
                                style={{paddingBottom: "0.5rem"}}
                                autoComplete="off"
                                id="account-password"
                                name="account-password"
                                label="Password"
                                type="password"
                                inputProps={{
                                    style: {paddingBottom: "0.5rem"}
                                }}
                                InputLabelProps={{
                                    sx: {top: "-7px", "&.MuiInputLabel-shrink": {top: "0px"}},
                                }}
                                error={passwordError}
                            />
                        </GridContainer> : null
                    }
                </DialogContent>
                <DialogActions>
                    <ButtonLightGray onClick={handleOnClose}>
                        Cancel
                    </ButtonLightGray>
                    <ButtonGradient variant="contained" color="primary" type='submit'>
                        Delete account
                    </ButtonGradient>
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default DeleteAccountDialog